export default __webpack_public_path__ + "static/media/fondo-00.a0e963d0.jpg";